module.exports = __webpack_public_path__ + "img/154.13cccade.png";